module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    staticClass: "app weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchstart": "",
      "data-evt-touchmove": "",
      "data-evt-touchend": ""
    },
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.checkTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.checkTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.checkTouchEnd($event)
      }
    }
  }, [_c('div', {
    ref: "cdBox",
    staticClass: " weex-ct weex-div",
    class: ['cell_div_box'],
    style: (_vm._px2rem(_vm.changeStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "leftBox",
    staticClass: " weex-ct weex-div",
    class: ['threeLeftButton'],
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.buttonsText), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: " weex-ct weex-div",
      class: ['button_style'],
      style: (_vm._px2rem(_vm.backColorChange(index), 75)),
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.alertMessage(index)
        }
      }
    }, [_c('p', {
      staticClass: "button_text weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.colorChange(index), 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "midBox",
    staticClass: " weex-ct weex-div",
    class: ['cell1'],
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("slideSlot", null, {})], 2), _vm._v(" "), _c('div', {
    ref: "rightBox",
    staticClass: " weex-ct weex-div",
    class: ['threeRightButton'],
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.buttonsText), function(item, index) {
    return _c('div', {
      key: 'info2' + index,
      staticClass: " weex-ct weex-div",
      class: ['button_style'],
      style: (_vm._px2rem(_vm.backColorChange(index), 75)),
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.alertMessage(index)
        }
      }
    }, [(item.value.length >= 4) ? _c('div', {
      staticClass: "button_text weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: " weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.colorChange(index), 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.value.slice(0, item.value.length / 2)))]), _vm._v(" "), _c('p', {
      staticClass: " weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.colorChange(index), 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.value.slice(2, 5)))])]) : _vm._e(), _vm._v(" "), (item.value.length <= 3) ? _c('div', {
      staticClass: "button_text weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: " weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.colorChange(index), 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.value.slice(0, item.value.length)))])]) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-846dbf60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-846dbf60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-swipe-cell/index.vue
// module id = 638
// module chunks = 0 1